/**
 * IvyDockTypingIndicator — 3-dot violet pulse shown while awaiting a blocking
 * response from /api/ivy/chat (Phase 2D).
 *
 * Explicit non-goal: NOT an SSE stream renderer. Phase 3+ streaming will
 * introduce a separate token-by-token renderer. This component only animates
 * while `visible` is true, to cover the 1-2s wait during a blocking POST.
 *
 * CSS keyframes live in src/index.css as `ivyDockTyping` + `.ivy-dock-typing-dot`
 * to match the existing convention (ivyPulse, ivyFabBreathe).
 */
interface IvyDockTypingIndicatorProps {
  visible: boolean
}

export default function IvyDockTypingIndicator({ visible }: IvyDockTypingIndicatorProps) {
  if (!visible) return null
  return (
    <div
      className="inline-flex items-center gap-1 px-1 py-0.5"
      role="status"
      aria-label="Ivy is thinking"
    >
      <span className="ivy-dock-typing-dot" />
      <span className="ivy-dock-typing-dot" />
      <span className="ivy-dock-typing-dot" />
    </div>
  )
}
